import F84Game from "../Game";
import GameConfig from "./data/GameConfig";

type SoundConfig = Phaser.Types.Sound.SoundConfig;
type SoundMarker = Phaser.Types.Sound.SoundMarker;

export default class SoundManager {
    game: F84Game;
    playedSounds: string[] = [];

    private _muted: boolean;
    private _volume: number;

    get muted(): boolean { return this._muted; }
    set muted(value: boolean) { this._muted = value; }

    get volume():number { return this._volume; }
    set volume(value: number) { this._volume = value; }

    constructor(game: F84Game, volume: number) {
        this.game = game;
        this._muted = false;
        this._volume = volume;
    }

    public add(key: string, config?: SoundConfig) : Phaser.Sound.BaseSound | null {
        // if (this._muted) return;
        if (!this.exists(key, true)) return null;
        const c = (config) ? config : { volume: this._muted ? 0 : this._volume };
        if (!c.volume) c.volume = this._muted ? 0 : this.volume;
        else c.volume *= this._muted ? 0 : this._volume;
        return this.game.sound.add(key, c);
    }

    public get(key: string): Phaser.Sound.BaseSound {
        return this.game.sound.get(key);
    }

    public getAll(key: string): Phaser.Sound.BaseSound[] {
        return this.game.sound.getAll(key);
    }

    public play(key: string, playOnce = false, config?: SoundConfig | SoundMarker): void {
        if ((playOnce && this.playedSounds.find((s) => s == key)) || this._muted || !this.exists(key, true)) return;

        let sfxConfig: any = { volume: this._volume };
        if (config) {
            if ((config as SoundMarker).config) {
                const marker = config as SoundMarker;
                if (marker.config) {
                    if (marker.config.volume) marker.config.volume *= this._volume;
                    else marker.config.volume = this._volume;
                }
                else marker.config = { volume: this._volume };
            } else {    
                const soundConfig = config as SoundConfig;
                if (soundConfig.volume) soundConfig.volume *= this._volume;
                else soundConfig.volume = this._volume;
            }
            sfxConfig = config;
        }
        this.game.sound.play(key, sfxConfig);
        if (playOnce) this.playedSounds.push(key);
    }

    public playVO(key: string, playOnce = false, config?: SoundConfig | SoundMarker): void {
        if(this._muted) return;
        if (GameConfig.get("enableVoiceOver")) {
            this.play(key, playOnce, config);
        }
    }

    public stop(key: string): void {
        this.game.sound.stopByKey(key);
    }

    public exists(key: string, debug = false): boolean {
        const exists = this.game.cache.audio.has(key);
        if (debug && !exists) console.log(`WARNING: audio key '${key}' does not exist within the audio cache!`);
        return exists;
    }
}
